import Export from './src/export.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToExport: SFCWithInstall<typeof Export> = withInstall(Export)

export * from './src/instance'
